import getApiClient from 'src/utils/getApiClient'
import { ApiTownInfoParamsGet, ApiTownInfoResponseGet } from 'src/layouts/core-layout/components/CoreSearch/api/apiTownInfo.types'

const apiClient = getApiClient()

export default {
  get(params: ApiTownInfoParamsGet) {
    return apiClient.get<ApiTownInfoResponseGet>('/api/town/info/', {
      params,
    })
  },
}
